import cn from "classnames";
import styles from "./Preview.module.scss";

export const ChicagoPreview = () => (
  <div className={cn(styles.preview, styles.previewChicago)}>
    <div className={cn(styles.tag, styles.tagTop)}>Title of your work</div>
    <div className={styles.title}>Chicago formatting example</div>
    <div className={styles.bottom}>
      <div className={styles.tag}>Your name</div>
      <div className={styles.tag}>Course name</div>
      <div className={styles.tag}>Due date</div>
    </div>
  </div>
);
